import { c as _c } from "react/compiler-runtime";
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
export type FlagProps = {
  className?: string;
  code: Iso3166TwoDigitCountryCode;
  testID?: string;
};
const Flag = t0 => {
  const $ = _c(3);
  const {
    code,
    testID,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `fp-f f-${code} w-5 h-[15px] bg-senary ${className}`;
  let t3;
  if ($[0] !== t2 || $[1] !== testID) {
    t3 = <div className={t2} data-testid={testID} />;
    $[0] = t2;
    $[1] = testID;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
export default Flag;